const { getRuntimeConfig } = require('./runtime-config')

module.exports = function () {
  if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'development') {
    return getRuntimeConfig().environment
  }
  if (process.env.VUE_APP_MODE) {
    return process.env.VUE_APP_MODE
  }
  return 'dev'
}
